import React from 'react';

import CheckboxInput from '../../../Form/Checkbox';

export default function Checkbox({ isSelected, onChange, disabled }) {
  return (
    <div className="pl-2">
      <CheckboxInput
        name="checkbox"
        label=""
        value={isSelected}
        onChange={onChange}
        style={{ paddingTop: 0 }}
        disabled={disabled}
      />
    </div>
  );
}
